import axios from "axios";

export async function fetchData() {
  return axios.get(`${process.env.REACT_APP_API_ENDPOINT}/main/dashboard`);
}
